import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

import initForm from "./initForm";
import createInputParts from "./createInputParts";
import addEventListeners from "./addEventListeners";
import val from "./val";
import createConditions from "./createConditions";

/**
* VuwSearchForm (extends VuwerComponent)
* @options
* - {String} inputClassName
* - {String} keywordQuery
* - {String} keywordDisp
* - {Object} buttonText
* - {Function} onSubmit
*/
vuwer.appendKlass("VuwSearchForm", {
	inputClassName: "search-inp",
	keywordQuery: "q",
	keywordDisp: "キーワード",
	filterOffMode: true,
	
	onSubmit(val) {},
	
	...initForm,
	...createInputParts,
	...addEventListeners,
	...val,
	...createConditions,
	
	/**
	 * [コンストラクタ]
	 * @param {Object} [opt]
	 * @returns this
	 */
	_initialize(opt) {
		if( Klass("VuwSearchForm").parent._initialize.call(this, opt) ) {
			this.onReady(this._onReadyDefault);
			return this;
		} else {
			return false;
		}
	},
	
	/**
	 * DOM操作の準備完了コールバック
	 * @param {$Object} $self
	 * @returns this
	 */
	_onReadyDefault($self) {
		if(!$self) {
			return false;
		}
		
		$self.addClass("vuw-search-form")
		.on("submit", e => {
			e.preventDefault();
			$(e.currentTarget).trigger("blur");
			
			// コールバックの実行
			u_.isFunction(this.onSubmit) && this.onSubmit( this.getVal() );
		})
		// テキスト入力.フォーカスで全選択
		.on("focus", ".inp[type='text']", e => {
			if( !$(e.currentTarget).hasClass("inp-date") ) {
				e.currentTarget.select();
			}
		})
		// 検索ボタン
		.on("click", ".btn-submit", e => {
			e.preventDefault();
			$(e.currentTarget).trigger("blur");
			this.$self.trigger("submit");
		})
		// クリアボタン
		.on("click", ".btn-clear", e => {
			e.preventDefault();
			$(e.currentTarget).trigger("blur");
			this.clearVal();
		})
		// [press Enter then submit]
		.on("keypress", "input", e => {
			(e.keyCode === 13) && this.$self.trigger("submit");
			return (e.keyCode !== 13);
		});
	},
});
